import axios from "../axios";

class ShipmentService {
  static Instance() {
    return new ShipmentService();
  }

  createShipment(request) {
    return axios.post("api/shipment", request);
  }

  updateShipment(request) {
    return axios.post("api/shipment/update", request);
  }

  fetchShipmentDetails(purchaseOrderId) {
    return axios.get("api/shipment/details?purchaseOrderId=" + purchaseOrderId);
  }

  updateShipmentDetails(containerID, request) {
    return axios.post(
      "api/shipment/details/update?containerID=" + containerID,
      request
    );
  }

  fetchShipmentDataCount(request) {
    return axios.post("api/shipment/counts", request).then(res => res.data);
  }

  fetchShipmentData(viewKey, request) {
    return axios.post("api/shipment/list?type=" + viewKey, request).then(res => res.data);
  }

  fetchShipmentDetentionData(request) {
    return axios.post("api/shipment/list/detention", request);
  }

  fetchTrackingDetails(containerNum) {
    return axios.post(
      "api/container/fetch/searates/tracking?containerNum=" + containerNum
    );
  }
  deleteShipment(containerID) {
    return axios.post("api/shipment/delete?containerID=" + containerID);
  }
  exportToExcel(type, request) {
    return axios.post("/api/shipment/list/export?type=" + type, request, {
      responseType: "blob",
    });
  }
}

export default ShipmentService.Instance();
